/**
 * 학습 페이지로 이동하면서 필기를 바로 여는 주소 파라미터 (JCG-3000).
 *
 * `/theory/db/normalization?open=note` 로 들어오면
 *  - 데스크탑 셸: 우측 사이드바를 펼치고(ArticleShell) 필기 Section 을 펼쳐 편집기에 포커스(Note)
 *  - 클래식/모바일: 하단 도구 Dock 의 필기 시트를 연다(Note)
 * 처리 후에는 Note 가 파라미터를 주소에서 지워 새로고침해도 다시 열리지 않게 한다.
 */

const NOTE_OPEN_QUERY = "open";
const NOTE_OPEN_VALUE = "note";

/** 페이지로 이동해 필기를 여는 링크 */
export function buildPageNoteHref(pagePath: string): string {
  return `${pagePath}?${NOTE_OPEN_QUERY}=${NOTE_OPEN_VALUE}`;
}

/** 현재 주소가 필기 열기를 요청하는지 (클라이언트 전용) */
export function hasNoteOpenParam(): boolean {
  if (typeof window === "undefined") return false;
  return new URLSearchParams(window.location.search).get(NOTE_OPEN_QUERY) === NOTE_OPEN_VALUE;
}

/** 필기 열기 파라미터를 주소에서 지운다(히스토리 항목은 늘리지 않는다). */
export function clearNoteOpenParam(): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  if (url.searchParams.get(NOTE_OPEN_QUERY) !== NOTE_OPEN_VALUE) return;
  url.searchParams.delete(NOTE_OPEN_QUERY);
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}
